export default function authHeader(basic_auth = false) {

  if (basic_auth) {
    const apiKey = "api-key:" + process.env.VUE_APP_API_KEY;
    const encodedKey = btoa(apiKey);
    return {
      Authorization: "Basic " + encodedKey,
      "Content-Type": "multipart/form-data",
    };
  }

  let user = JSON.parse(localStorage.getItem("user"));
  let token = localStorage.getItem('jwt_token');

  if (user && user.token) {
    return {
      Authorization: "Bearer " + user.token,
      "Content-Type": "multipart/form-data",
    };
  } else {
    return {
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data",
    };
  }
}